module.exports = __webpack_public_path__ + "static/new-plan-c4af0d16f7c5773c84fc1bace5c5f2d3.png";